<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Document Management</h1>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              Select a form, then review the document upload fields configured for that process.
            </p>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Forms
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ selectable_forms.length }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-folder2-open"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Document Fields
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ documents.length }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-file-earmark-check"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <div class="d-md-none">
      <div class="input-group">
        <span class="input-group-text bg-light border-0 rounded-start-pill">
          <i class="bi bi-search text-secondary"></i>
        </span>
        <input
          v-model.trim="search_query"
          type="text"
          class="form-control form-control-sm bg-light border-0 rounded-end-pill"
          placeholder="Search documents..."
        />
      </div>
    </div>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-grid-3x3-gap-fill"></i>
            </div>
            <div>
              <div class="entity-section-title fw-bold fs-6">Form Documents</div>
              <div class="small text-secondary">
                {{ selected_form ? selected_form.form_name : 'Select a form to load its document fields.' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <select
              v-model="selected_form_id"
              class="form-select form-select-sm rounded-3"
              :disabled="loading_forms"
            >
              <option value="">{{ loading_forms ? 'Loading forms...' : 'Select Form' }}</option>
              <option v-for="form in selectable_forms" :key="form.id" :value="String(form.id)">
                {{ form.form_name }}
              </option>
            </select>
            <select
              v-model="selected_rule_id"
              class="form-select form-select-sm rounded-3"
              :disabled="!selected_form_id || loading_documents || loading_rules || !rules.length"
            >
              <option value="">{{ compliance_rule_placeholder }}</option>
              <option v-for="rule in rules" :key="rule.id" :value="String(rule.id)">
                {{ rule.name }}
              </option>
            </select>
            <select
              v-model="selected_transition_rule_id"
              class="form-select form-select-sm rounded-3"
              :disabled="!selected_form_id || loading_transition_rules || !transition_rules.length"
            >
              <option value="">{{ transition_rule_placeholder }}</option>
              <option v-for="transition_rule in transition_rules" :key="transition_rule.id" :value="String(transition_rule.id)">
                {{ transition_rule.name }}
              </option>
            </select>
            <div class="input-group d-none d-md-flex">
              <span class="input-group-text bg-light border-0 rounded-start-pill">
                <i class="bi bi-search text-secondary"></i>
              </span>
              <input
                v-model.trim="search_query"
                type="text"
                class="form-control form-control-sm bg-light border-0 rounded-end-pill text-x"
                placeholder="Search document fields..."
                :disabled="!selected_form_id"
              />
            </div>
            <button type="button" class="btn btn-light btn-sm rounded-3" aria-label="Filter">
              <i class="bi bi-funnel"></i>
            </button>
            <button type="button" class="btn btn-light btn-sm rounded-3" aria-label="Sort">
              <i class="bi bi-sliders"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-3">Document Field</div>
          <div class="col-lg-1">Type</div>
          <div class="col-lg-4">Compliance Rule</div>
          <div class="col-lg-3">Transition Rule</div>
          <div class="col-lg-1"></div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>{{ loading_forms ? 'Loading forms...' : 'Loading document fields...' }}</span>
      </div>

      <div v-else-if="!selected_form_id" class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-ui-checks-grid fs-3"></i>
        </div>
        <div class="fw-bold mb-1">Select a Form</div>
        <div class="text-secondary small">Only forms are loaded at first. Document fields appear after you choose a form.</div>
      </div>

      <div v-else-if="paginated_documents.length" class="d-flex flex-column gap-2">
        <article
          v-for="document in paginated_documents"
          :key="document.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="entity-name-block col-12 col-lg-3 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i :class="[
                  'fs-5',
                  document.status === 'Required' ? 'bi bi-file-earmark-text text-primary' : 'bi bi-file-earmark-lock text-secondary'
                ]"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ document.name }}</div>
                <div class="entity-updated text-secondary small">{{ document.description || 'Document ready for preview and action.' }}</div>
              </div>
            </div>

            <div class="col-12 col-sm-4 col-lg-1">
              <span class="text-xs fw-semibold text-secondary">{{ document.type }}</span>
            </div>

            <div class="col-12 col-lg-4 d-flex flex-column gap-2">
              <label class="d-inline-flex align-items-center gap-2 mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="is_document_assigned_to_selected_rule(document)"
                  :disabled="!selected_rule_id || !document.section_question_id || updating_document_rule_id === String(document.section_question_id)"
                  :aria-label="get_selected_rule_checkbox_label(document)"
                  @change="toggle_document_selection(document)"
                />
                <span
                  class="text-xxs fw-semibold"
                  :class="get_selected_rule_checkbox_class(document)"
                >
                  {{ get_selected_rule_checkbox_label(document) }}
                </span>
              </label>

              <span class="badge rounded-pill text-bg-light border text-secondary entity-rule-chip align-self-start">
                {{ selected_rule ? selected_rule.name : get_document_rule_label(document) }}
              </span>
            </div>

            <div class="col-12 col-lg-3 d-flex flex-column gap-2">
              <label class="d-inline-flex align-items-center gap-2 mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="is_document_assigned_to_selected_transition_rule(document)"
                  :disabled="!selected_transition_rule_id || !document.section_question_id || updating_document_rule_id === `transition-${document.section_question_id}`"
                  :aria-label="get_transition_rule_checkbox_label(document)"
                  @change="toggle_transition_rule_document(document)"
                />
                <span
                  class="text-xxs fw-semibold"
                  :class="get_transition_rule_checkbox_class(document)"
                >
                  {{ get_transition_rule_checkbox_label(document) }}
                </span>
              </label>

              <span class="badge rounded-pill text-bg-light border text-secondary entity-rule-chip align-self-start">
                {{ selected_transition_rule ? selected_transition_rule.name : 'No transition rule' }}
              </span>
            </div>

            <div class="col-12 col-lg-1 d-flex justify-content-start justify-content-lg-end align-items-center gap-2">
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                @click="preview_document(document)"
                data-bs-toggle="modal"
                data-bs-target="#preview_document_modal"
              >
                View
              </button>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-folder2-open fs-3"></i>
        </div>
        <div class="fw-bold mb-1">No Document Fields Found</div>
        <div class="text-secondary small">This form has no file or document upload questions.</div>
      </div>

      <div v-if="!loading && paginated_documents.length" class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3">
        <div class="text-secondary text-xs">
          Showing {{ pagination_label }}
        </div>

        <nav aria-label="Documents pagination">
          <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
            <button
              type="button"
              class="btn btn-sm btn-light border-0 rounded-0 px-2"
              @click="set_page(current_page - 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              v-for="page in total_pages"
              :key="page"
              type="button"
              class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
              :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
              @click="set_page(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
              @click="set_page(current_page + 1)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </section>
  </div>
</div>

<teleport to="body">
  <div
    class="modal fade"
    id="preview_document_modal"
    tabindex="-1"
    aria-labelledby="preview_document_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xs mb-0" id="preview_document_modal_label">
            Document Preview
          </p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <div v-if="selected_document" class="d-flex flex-column">
            <div class="p-4 border-bottom">
              <div class="fw-bold">{{ selected_document.name }}</div>
              <div class="text-secondary small mt-1">
                {{ selected_document.description || 'No document description available.' }}
              </div>
            </div>

            <div class="p-4">
              <div class="bg-light rounded-4 border p-3 mb-3 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                  <div>
                    <div class="fw-bold secondary-color">Compliance Rule</div>
                    <div class="small text-secondary">Selected compliance rule values for this document field.</div>
                  </div>
                  <span
                    class="badge rounded-pill"
                    :class="is_document_assigned_to_selected_rule(selected_document) ? 'text-bg-success' : 'text-bg-secondary'"
                  >
                    {{ get_selected_rule_checkbox_label(selected_document) }}
                  </span>
                </div>

                <div v-if="selected_rule" class="row g-3">
                  <div class="col-12">
                    <label class="modal-form-label form-label text-xxs">Rule Name</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="selected_rule.name"
                      readonly
                    />
                  </div>
                  <div class="col-12">
                    <label class="modal-form-label form-label text-xxs">Description</label>
                    <textarea
                      class="form-control rounded-3 bg-white"
                      rows="3"
                      :value="selected_rule.description || 'No rule description provided.'"
                      readonly
                    ></textarea>
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="modal-form-label form-label text-xxs">Initial Grace</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="format_rule_duration(selected_rule.initial_grace_period)"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="modal-form-label form-label text-xxs">Frequency</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="format_rule_duration(selected_rule.frequency)"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="modal-form-label form-label text-xxs">Recurring Grace</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="format_rule_duration(selected_rule.recurring_grace_period)"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-5">
                    <label class="modal-form-label form-label text-xxs">Logic</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="selected_rule.logical_operator || 'AND'"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-7">
                    <label class="modal-form-label form-label text-xxs">Trigger Status</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="get_rule_trigger_status_label(selected_rule)"
                      readonly
                    />
                  </div>
                  <div class="col-12">
                    <div class="d-flex flex-wrap gap-2">
                      <span class="badge rounded-pill text-bg-light border text-secondary">
                        {{ selected_document.status }}
                      </span>
                      <span
                        v-for="assignment in get_document_rule_assignments(selected_document)"
                        :key="`preview-${selected_document.section_question_id}-${assignment.rule_id}`"
                        class="badge rounded-pill text-bg-light border text-secondary"
                      >
                        {{ assignment.rule_name }}
                      </span>
                      <span
                        v-if="get_assigned_rule_document(selected_document)?.compliance_field_id"
                        class="badge rounded-pill text-bg-light border text-secondary"
                      >
                        Field #{{ get_assigned_rule_document(selected_document).compliance_field_id }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="small text-secondary">
                  Select a compliance rule to see whether this document field is assigned to it.
                </div>
              </div>

              <div class="bg-light rounded-4 border p-3 mb-3 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                  <div>
                    <div class="fw-bold secondary-color">Transition Rule</div>
                    <div class="small text-secondary">Selected workflow transition rule for this document field.</div>
                  </div>
                  <span
                    class="badge rounded-pill"
                    :class="is_document_assigned_to_selected_transition_rule(selected_document) ? 'text-bg-success' : 'text-bg-secondary'"
                  >
                    {{ get_transition_rule_checkbox_label(selected_document) }}
                  </span>
                </div>

                <div v-if="selected_transition_rule" class="row g-3">
                  <div class="col-12">
                    <label class="modal-form-label form-label text-xxs">Transition</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="selected_transition_rule.name"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="modal-form-label form-label text-xxs">Type</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="get_transition_rule_type_label(selected_transition_rule)"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="modal-form-label form-label text-xxs">Status</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="get_transition_rule_status_label(selected_transition_rule)"
                      readonly
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="modal-form-label form-label text-xxs">Conditions</label>
                    <input
                      type="text"
                      class="form-control rounded-3 bg-white"
                      :value="get_transition_rule_condition_label(selected_transition_rule)"
                      readonly
                    />
                  </div>
                  <div class="col-12">
                    <div class="d-flex flex-wrap gap-2">
                      <span class="badge rounded-pill text-bg-light border text-secondary">
                        {{ selected_document.status }}
                      </span>
                      <span class="badge rounded-pill text-bg-light border text-secondary">
                        Document #{{ selected_document.section_question_id }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="small text-secondary">
                  Select a transition rule to see whether this document field is assigned to it.
                </div>
              </div>
            </div>
          </div>
          <div v-else class="p-4 text-center text-secondary text-xs">No document selected.</div>
        </div>
      </div>
    </div>
  </div>
</teleport>
